import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import { isProd, env } from '@/config/host';
import { setTitle } from '@/common/tools';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;

// issue 处理
// https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
// https://github.com/hsingyin/hsingyin.site/issues/7#issue-586782745
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((error) => error);
};

const router = new VueRouter({
  mode: 'history',
  base: isProd ? '/index/' : '/',
  routes,
  scrollBehavior() {
    // 解决页面回退留白问题
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 1 });
      }, 0);
    });
  },
});

// 导航守卫
router.afterEach((route, fromRoute) => {
  const { title = '小拉出行', style } = route.meta;

  setTitle(title, style);

  // 更新 PageSpy 展示标题
  if (
    window.$pageSpy &&
    typeof window.$pageSpy.updateRoomInfo === 'function' &&
    !isProd
  ) {
    window.$pageSpy.updateRoomInfo({
      title: `${route.meta?.title?.trim() || '司机H5'} (${env.toUpperCase()})`,
    });
  }

  // 记录上一个路由的地址
  if (fromRoute) {
    route.meta.lastPath = fromRoute.fullPath;
  }
});

export default router;
